import { Keyboard } from 'lucide-react'

export const KbdIcon = Keyboard